import { providers, Signer, utils } from "ethers"

import Contract from "./Contract"
import { HonestFarmerClubV2ABI } from "../../../artifacts/polygon/abi"

class HonestFarmerClubV2 extends Contract {
	constructor(
		address: string,
		signerOrProvider: Signer | providers.Provider,
	) {
		super(address, HonestFarmerClubV2ABI, signerOrProvider)
	}

	async isApprovedForAll(address: string, operatorAddress: string) {
		return this.callFunction<
			[typeof address, typeof operatorAddress],
			boolean
		>("isApprovedForAll", address, operatorAddress)
	}

	async setApprovalForAll(operatorAddress: string, isApproved: boolean) {
		return this.callFunction<[typeof operatorAddress, typeof isApproved]>(
			"setApprovalForAll",
			operatorAddress,
			isApproved,
		)
	}

	async safeTransferFrom(from: string, to: string, id: number) {
		return this.callFunction<
			[typeof from, typeof to, typeof id, number, unknown]
		>("safeTransferFrom", from, to, id, 1, utils.arrayify(0))
	}

	async uri(tokenId: number) {
		return this.callFunction<[typeof tokenId], string>("uri", tokenId)
	}
}

export default HonestFarmerClubV2
